import React, { useState } from 'react'

import { UserWarningStatus } from '~/api-definition/definition'
import { Button } from '~/components/action/Button'
import { Modal } from '~/components/action/Modal'
import { UserWarningStatusIcon } from '~/components/icons'
import { userWarningStatusColor, userWarningStatusLabel } from '~/libs/user'

import { FAQLink } from '../FAQLink'

export const UserWarningStatusIconButton: React.FC<{
  userWarningStatus: UserWarningStatus
}> = (props) => {
  const [showWarningStatus, setShowWarningStatus] = useState(false)

  return (
    <>
      <Modal
        isOpen={showWarningStatus}
        setIsOpen={setShowWarningStatus}
        title={userWarningStatusLabel(props.userWarningStatus)}
        body={
          <div className="text-[13px]">
            以下の事情により{userWarningStatusLabel(props.userWarningStatus)}
            ユーザーになっています。
            {userWarningStatusLabel(props.userWarningStatus)}
            ユーザーに関する詳しい説明は
            <FAQLink />
            をご確認ください
            <div className="mt-4 bg-[#F8F3EA] px-4 py-3 rounded flex items-start gap-2">
              <span className="font-bold">理由</span>
              <ul className="space-y-1 list-disc pl-4">
                {props.userWarningStatus.reasons.map((reason, i) => {
                  return <li key={i}>{reason}</li>
                })}
              </ul>
            </div>
          </div>
        }
        actionButtons={
          <Button
            type="button"
            variant="functionWeak"
            className="w-full"
            onClick={(e) => {
              e.stopPropagation()
              setShowWarningStatus(false)
            }}
          >
            OK
          </Button>
        }
      />
      <button type="button" onClick={() => setShowWarningStatus(true)}>
        <UserWarningStatusIcon
          fill={userWarningStatusColor(props.userWarningStatus)}
        />
      </button>
    </>
  )
}
